import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useCallback, useMemo, useState } from 'react'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import ECharts from '~/components/echarts'
import Select from '~/components/select'
import { awsRDSClusterIopsMetricsResourceIdChartPath, awsRDSClusterVolumeMetricsResourceIdChartPath } from '~/routes'

export default function AWSRDSClusterMetricsCharts({ organizationId: orgId, resourceId: reId }) {
  const [params, setParams] = useState({ metrics_time_frame: '1w' })
  const metricsTimeFrames = useMemo(
    () => [
      { label: t`1 Week`, value: '1w', default: true },
      { label: t`1 Month`, value: '1m' },
      { label: t`3 Months`, value: '3m' },
    ],
    [],
  )

  const onChange = useCallback((name, values) => {
    // update params when a filter is selected
    setParams((prevParams) => ({ ...prevParams, [name]: values }))
  }, [])

  const awsRDSClusterVolumeMetricsResourceIdChartUrl = useMemo(
    () => awsRDSClusterVolumeMetricsResourceIdChartPath(orgId, reId),
    [orgId, reId],
  )
  const awsRDSClusterIopsMetricsResourceIdChartUrl = useMemo(
    () => awsRDSClusterIopsMetricsResourceIdChartPath(orgId, reId),
    [orgId, reId],
  )

  return (
    <div className='card'>
      <h3 className='card-header'>
        <Trans>Cloudwatch Information</Trans>
      </h3>
      <div className='card-body'>
        <div className='row mb-3 gx-2 gy-2 align-items-center'>
          <div className='col-sm-4'>
            <Select
              label={t`Time Frame`}
              name='metrics_time_frame'
              onChange={onChange}
              options={metricsTimeFrames}
              selected={params.metrics_time_frame}
            />
          </div>
        </div>
        <Tabs id='uncontrolled-cluster-metrics-tabs' className='mb-3' defaultActiveKey='storage-tab'>
          <Tab eventKey='storage-tab' title={t`Storage`}>
            <div className='row g-0'>
              <div className='col-sm-12'>
                <ECharts
                  title={t`Volume Bytes Used`}
                  chartInfoTitle='aws_rds_cluster_volume_bytes_used'
                  url={awsRDSClusterVolumeMetricsResourceIdChartUrl}
                  params={params}
                />
              </div>
            </div>
          </Tab>
          <Tab eventKey='iops-tab' title={t`IOPS`} mountOnEnter>
            <div className='row g-0'>
              <div className='col-sm-12'>
                <ECharts
                  title={t`Disk Operations`}
                  chartInfoTitle='aws_rds_cluster_disk_operations'
                  url={awsRDSClusterIopsMetricsResourceIdChartUrl}
                  params={params}
                />
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}
